import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from "@mui/material";
import AccentureIcon from "assets/AccentureIcon";
import { CustomConfirmationDialog } from "./home.styled";

interface ConfirmationDialogProps {
    open: boolean;
    title: string;
    message: string;
    isLoading?: boolean;
    loadingText?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
    confirmButtonColor?: "error" | "primary" | "warning";
    onClose: () => void;
    onConfirm: () => void;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    open,
    title,
    message,
    isLoading = false,
    onClose,
    onConfirm
}) => {
    return (
        <CustomConfirmationDialog open={open} onClose={onClose}>
            <Box sx={{display:"flex", flexDirection:"column", alignItems:"center"}}>
                <Box sx={{ display: "flex", justifyContent: "center", m:4 }}>
                    <AccentureIcon />
                </Box>
                <DialogTitle fontWeight="bold" sx={{p:0, m:0}}>{title}</DialogTitle>
            </Box>
            
            <DialogContent>{message}</DialogContent>
            <DialogActions sx={{display:"flex", justifyContent:"space-evenly", marginBottom: 2}}>
                <Button 
                    onClick={onClose}
                    disabled={isLoading}
                    variant="outlined"
                >
                    Cancel
                </Button>
                <Button 
                    onClick={onConfirm}
                    color="error"
                    variant="outlined"
                    disabled={isLoading}
                >
                    {isLoading ? "Deleting..." : "Delete"}
                </Button>
            </DialogActions>
        </CustomConfirmationDialog>
    );
};

